import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';

class MiniCurtain extends PureComponent {
  render() {
    const { children, className, hidden, style } = this.props;
    return (
      <div
        className={classnames(
          className,
          'MiniCurtain d-flex align-center jc-center text-center fd-col'
        )}
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: hidden ? 'black' : 'rgba(0,0,0,0.5)',
          ...style,
        }}
      >
        {children}
      </div>
    );
  }
}

MiniCurtain.propTypes = {
  children: PropTypes.node,
  hidden: PropTypes.bool,
};

export default MiniCurtain;
